export interface Callback<T extends Element> {
    (el: T): void;
}

function isDocument(el: unknown): el is Document {
    return el === document;
}

const ONCE_CALL_MAP = new WeakMap<Element, Callback<Element>[]>();

function callOnce<T extends Element>(el: T, callback: Callback<T>): void {
    if (!ONCE_CALL_MAP.has(el)) {
        ONCE_CALL_MAP.set(el, []);
    }

    const arr = ONCE_CALL_MAP.get(el)!;

    if (!arr.includes(callback as Callback<Element>)) {
        arr.push(callback as Callback<Element>);
        callback(el);
    }
}

export function defineDrupalBehavior<T extends Element = HTMLDivElement>(
    name: string,
    selector: string,
    callback: Callback<T>
): void {
    window.Drupal.behaviors[name] = {
        attach(context) {
            if (isDocument(context)) {
                context.querySelectorAll<T>(selector).forEach((el) => callOnce(el, callback));
            } else if (context.matches(selector)) {
                callOnce(context as unknown as T, callback);
            } else {
                context.querySelectorAll<T>(selector).forEach((el) => callOnce(el, callback));
            }
        },
    };
}
